import { render, staticRenderFns } from "./surveyshow.vue?vue&type=template&id=835e5ebe"
import script from "./surveyshow.vue?vue&type=script&lang=js"
export * from "./surveyshow.vue?vue&type=script&lang=js"
import style0 from "./surveyshow.vue?vue&type=style&index=0&id=835e5ebe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports